import React from "react";
import {
    InstantSearch,
    Hits,
    SearchBox,
    Pagination,
} from 'react-instantsearch-dom';
import { Link } from "react-router-dom";
import { connectStateResults } from "react-instantsearch/connectors";

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
        }
    }

    closeSearch = () => {
        this.props
          .close()
    };
    render() {

        const Product = ({hit}) => {

            let parsed = '';

                if(hit.content.length > 0) {

                    parsed = hit.content[0].substring(0,250) + "...";
                }


            return      <Link to={hit.uri} onClick={() => this.closeSearch()} className="rob-search__result">
                              <div className={"rob-search__content vf"}>
                                  <h1>{hit.title}</h1>
                                  <p>{parsed}</p>
                                  <small>ayacancernetwork.org.nz/{hit.uri}</small>
                              </div>
                            <div className={hit.image ? "rob-search__image" : "rob-search__no-image"} style={{backgroundImage: `url(${hit.image})`}}></div>
                        </Link>
        };
        const Results = connectStateResults(
          ({ searchState }) =>
            searchState && searchState.query ? (
              <div>
                <Hits hitComponent={Product} />
                <Pagination />
              </div>
              ) : //<div>No query</div>
              null
        );

        const Search = () => {
            return (
              <div className="container">
                  <Results />
              </div>
            );
        }

        return <div className={this.props.active}>
            <div className="search">
                <div className="rob-list__title  rob-list__title--modal"><h2>Search</h2></div>
                <div>
                    <div className="row">
                        <div className="col-12">

                            <InstantSearch
                              appId="FM6EIXM2TO"
                              apiKey="da4cdd8d9ca03ccaa7d30d9e5cf6ad33"
                              indexName="AYA_dev"
                            >
                                <SearchBox/>
                                <Search/>
                            </InstantSearch>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    }
};

export default Search


// WEBPACK FOOTER //
// ./src/components/elements/modals/Search.js